export default __webpack_public_path__ + "static/media/tfg-icon-active.aff4a015.svg";